export default __webpack_public_path__ + "static/5_25-a2df7e21c8575427577b13f157349c05.png";